module.exports = __webpack_public_path__ + "static/media/扫码@2x.1d09a.png";